export class AssetModel {
  assetsSelected: string[];
  customers: AssetCustomerModel[];
  label: string;
  selected: boolean;

  constructor(country: any) {
    this.assetsSelected = [];
    this.customers = AssetModel.setCustomers(country.operator || []);
    this.label = country.country || '';
    this.selected = false;
  }

  private static setCustomers(customers: any[]): AssetCustomerModel[] {
    const custs: AssetCustomerModel[] = [];
    for (const cust of customers) {
      custs.push(new AssetCustomerModel(cust));
    }
    return custs;
  }

}

export class AssetCustomerModel {
  cats: AssetCatModel[];
  label: string;
  selected: boolean;

  constructor(customer: any) {
    this.label = customer.label || 'Engie';
    this.cats = AssetCustomerModel.setCats(customer.category || []);
    this.selected = false;
  }

  private static setCats(categories: any[]): AssetCatModel[] {
    const cats: AssetCatModel[] = [];
    for (const cat of categories) {
      cats.push(new AssetCatModel(cat));
    }
    return cats;
  }

}

export class AssetCatModel {
  label: string;
  assets: AssetCatAssetModel[];
  selected: boolean;

  constructor(cat: any) {
    this.label = cat.label || '?';
    this.assets = AssetCatModel.setAssets(cat.asset || []);
    this.selected = false;
  }

  private static setAssets(assetList: any[]): AssetCatAssetModel[] {
    const assets: AssetCatAssetModel[] = [];
    for (const asset of assetList) {
      assets.push(new AssetCatAssetModel(asset));
    }
    return assets;
  }

}

export class AssetCatAssetModel {
  cat: string;
  id: string;
  label: string;
  selected: boolean;

  constructor(asset: any) {
    this.cat = asset.category || '?';
    this.id = asset.code || '';
    this.label = asset.name || '?';
    this.selected = false;
  }

}

export class AssetSelectedModel {
  asset: string;
  assetLabel: string;
  country: string;
}
